<template>
  <div class="animated fade-in" v-if="!loading">
    <div v-if="!error">
      <document-folder-modal id="update-document_folder" :document_folder="document_folder" @onSave="(folder) => document_folder = folder"></document-folder-modal>
      <document-folder-delete-modal id="delete-document_folder" :document_folder="document_folder" @onDelete="$router.push('/documents/manage')"></document-folder-delete-modal>
      <h1 class="display-4 font-weight-lighter clearfix">
        {{ folder_name ? (document_folder ? document_folder.name : folder_name) + ' '  : 'Manage ' }} Documents
        <b-button-group class="float-right py-3">
          <b-button squared variant="outline-dark" v-b-modal.update-document_folder>
            <font-awesome-icon :icon="['fal', 'pencil']"></font-awesome-icon>
          </b-button>
          <b-button squared variant="outline-dark" v-b-modal.delete-document_folder>
            <font-awesome-icon :icon="['fal', 'trash']"></font-awesome-icon>
          </b-button>
        </b-button-group>
      </h1>
      <manage-document-folders class="my-4" :document_folder="document_folder"></manage-document-folders>
      <upload-table
              :folder_id="folder_id"
              :documents="documents"
              :manage_meta="true"
              :manage_permissions="true"
              :manage_cover="true"
              :permission_models="permission_models"
      ></upload-table>
    </div>
    <div v-if="error">
      <b-alert show>{{ error }}</b-alert>
    </div>
  </div>
</template>

<script>

import Document from "../../models/Document";
import DocumentFolder from "../../models/DocumentFolder";
import UploadTable from "../../components/documents/UploadTable";
import Customer from "../../models/Customer";
import ManageDocumentFolders from "../../components/documents/ManageDocumentFolders";
import DocumentFolderModal from "../../components/documents/DocumentFolderModal";
import DocumentFolderDeleteModal from "../../components/documents/DocumentFolderDeleteModal";
import {GREEDY_FETCH_ENTITY} from "@/store/action-types";

export default {
  name: "DocumentManage",
  components: {DocumentFolderDeleteModal, DocumentFolderModal, ManageDocumentFolders, UploadTable},
  props: ['folder_id'],
  data() {
    return {
      error: null,
      loading: true,
      folder_name: null,
      document_folder: null,
      documents: null,
      permission_models: null,
    };
  },
  methods: {
    populate() {
      this.document_folder = DocumentFolder.query().with(['documents.cover']).where('id', Math.abs(this.folder_id)).first();
      if(this.document_folder) {
        this.folder_name = this.document_folder.name;
        this.documents = this.document_folder.documents;
      } else {
        this.error = 'No documents found for `'+this.folder_name+'`.';
      }
      this.permission_models = Customer.query().orderBy('name').get();
    },
    fetch() {
      /*let filters = {};
      this.folder_name = (this.folder ? this.folder.split('-').join(' ').replace(/^(.)|\s+(.)/g, function ($1) {
        return $1.toUpperCase()
      }) : null);
      if(this.folder_name) {
        filters.name = this.folder_name;
      }*/
      let promises = [
        DocumentFolder.api().retrieve(this.folder_id),
        //this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: DocumentFolder, params: filters}),
        this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: Customer, params: {}}),
      ];
      return Promise.all(promises).then(() => {
        return this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: Document, params: {document_folder_id: this.folder_id}});
        //let folders = [];
        //let document_folders = DocumentFolder.query().where('name', filters.name).get() || [];
        // document_folders.forEach((folder) => {
        //   this.folder_id = folder.id;
        //   folders.push(folder.id);
        // });
        //return this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: Document, params: {document_folder_id: folders.join('|')}});
      });
    },
    onFolderChange() {
      this.error = null;
      this.loading = true;
      this.fetch().then(() => {
        this.populate();
        this.loading = false;
      });
    }
  },
  watch: {
    folder_id: function () {
      this.onFolderChange();
    }
  },
  created() {
    this.onFolderChange();
  }
};
</script>
